module.exports = __webpack_public_path__ + "static/Review-ipad-img-3-8a5cb0199bbee07f0d63adcd36c0bec2.jpeg";